/**
 * @generated SignedSource<<28a7a5853006d4e07f5037cfe36578dd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedContentModuleIconicDesign_browseContentModule$data = {
  readonly description: string | null;
  readonly mainImage: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "SbSharedContentModuleIconicDesign_browseContentModule";
};
export type SbSharedContentModuleIconicDesign_browseContentModule$key = {
  readonly " $data"?: SbSharedContentModuleIconicDesign_browseContentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedContentModuleIconicDesign_browseContentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedContentModuleIconicDesign_browseContentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mainImage",
      "storageKey": null
    }
  ],
  "type": "ContentModuleIconicDesign",
  "abstractKey": null
};

(node as any).hash = "fc7338ffd633dbb7ba8a2ebeb9d60e4a";

export default node;
